// src/features/staff/pages/StaffDetailsPage/components/StaffTabsNavigation.jsx

import React from 'react';
import { Paper, Tabs, Tab } from '@mui/material';

/** `tabs` is [{ key, label, icon }]; only the tabs the user may open are passed in */
export default function StaffTabsNavigation({ tabs, activeTab, onTabChange }) {
  return (
    <Paper sx={{ mt: 1 }}>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        aria-label="staff management tabs"
        variant="fullWidth"
        sx={{ '& .MuiTab-root': { minHeight: 48 } }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.key}
            label={tab.label}
            icon={tab.icon}
            iconPosition="start"
            id={`staff-tab-${index}`}
            aria-controls={`staff-tabpanel-${index}`}
          />
        ))}
      </Tabs>
    </Paper>
  );
}
